import { Button } from '../atoms/Button'
import { CalendarSyncIllustration } from '../../svg/CalendarSyncIllustration'
import { CodeSampleIllustration } from '../../svg/CodeSampleIllustration'
import { ConversationIllustration } from '../../svg/ConversationIllustration'
import { CustomBrandingIllustration } from '../../svg/CustomBrandingIllustration'
import { GDPRIllustration } from '../../svg/GDPRIllustration'
import { Multiplateform } from '../../svg/Multiplateform'
import React from 'react'
import { TranscriptIllustration } from '../../svg/TranscriptIllustration'
import { VideoRecordingIllustration } from '../../svg/VideoRecordingIllustration'
import { registerRedirect } from '../../utils/router'
import { wrapWordsWithLinks } from '../Pricing/PricingDetails'

export const FeaturesSection = () => {
    return (
        <div className="snap-start py-[100px] lg:pt-[160px] bg-neutral-900 px-[60px] w-full min-h-screen items-center flex flex-row justify-between">
            <div className="2xl:w-3/5 lg:max-w-screen-lg mx-auto flex flex-col gap-[64px]">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 gap-8">
                    <GridItem
                        children={<VideoRecordingIllustration />}
                        title="Raw Video"
                        description="Instant availability of video recordings from meetings in S3 buckets."
                    />
                    <GridItem
                        children={<TranscriptIllustration />}
                        title="Transcription and LLM Summaries"
                        description="Gladia with out of the box transcripts and LLM summaries. Or use another provider, or our Whisper v3 with vocabulary, timestamps and language detection."
                    />
                    <GridItem
                        children={<ConversationIllustration />}
                        title="Metadata"
                        description="Participant names, and speech timestamps."
                    />
                    <GridItem
                        children={<Multiplateform />}
                        title="Multiplatform Support"
                        description="2 simple HTTP requests to record Zoom, Meet and Teams."
                    />
                    <GridItem
                        children={<CalendarSyncIllustration />}
                        title="Calendar sync"
                        description="Easily connect your end user’s agenda."
                    />
                    <GridItem
                        children={<CodeSampleIllustration />}
                        title="Code Examples"
                        description="Compare LLM outputs, create LLM-connected interfaces and more."
                    />
                </div>
                <div className=" grid grid-cols-1 lg:grid-cols-2 mx-auto gap-9 lg:w-full 2xl:w-3/4">
                    <Button
                        name="View features"
                        onClick={() => (window.location.href = '/features')}
                        textColor="text-neutral-50"
                        color="green"
                        buttonClass="min-w-full"
                    />

                    <Button
                        name="Get your API Key"
                        onClick={registerRedirect}
                        buttonClass="min-w-full"
                        color="green"
                    />
                </div>
                <div className="w-3/4 grid grid-cols-2 mx-auto gap-8 justify-center">
                    <GridItem
                        children={<CustomBrandingIllustration />}
                        title="Custom branding"
                        description="Display your user's branding, add a custom name and chat message."
                    />
                    <GridItem
                        children={<GDPRIllustration />}
                        title="Compliance"
                        description="Data minimization is the core principle of our API, and we provide a DPA."
                    />
                </div>
            </div>
        </div>
    )
}

const GridItem = (props: {
    classGridItem?: string
    title: string
    description: string
    children: React.ReactNode
}) => {
    return (
        <div
            className={`flex flex-col items-center gap-4 ${props.classGridItem}`}
        >
            <div className="rounded-full bg-primary-500 w-[70px] h-[105px] justify-center items-center flex mx-auto text-neutral-900">
                {props.children}
            </div>
            <div className="flex flex-col gap-1 2xl:gap-4 text-center">
                <div className="text-bold font-sansCondensed text-base lg:text-lg 2xl:text-xl font-black uppercase text-primary-500">
                    {props.title}
                </div>
                <div className="text-sm lg:text-base 2xl:text-lg hidden 2xl:block text-primary-500 opacity-75">
                    {wrapWordsWithLinks(props.description)}
                </div>
            </div>
        </div>
    )
}
